export default {
    data: () => ({
        translations: {
            title: {
                el: "Στοιχεία Επιχείρησης",
                en: "Business Information",
                it: "Informazioni sull'azienda"
            },
            name: {
                el: "Όνομα Επιχείρησης",
                en: "Business Name",
                it: "Nome dell'azienda"
            },
            category: {
                el: "",
                en: "Basic Business Category",
                it: ""
            },
            country: {
                el: "Χώρα",
                en: "Country",
                it: "Paese"
            },
            telephone2: {
                el: "Τηλέφωνο Επιχείρησης 2",
                en: "Business Telephone Number 2",
                it: "Numero di telefono aziendale 2"
            },
            fullname: {
                el: "Ονοματεπώνυμο Ιδιοκτήτη",
                en: "Owner's Fullname",
                it: "Nome completo del proprietario"
            },
            address: {
                el: "Διεύθυνση",
                en: "Address",
                it: "Indirizzo"
            },
            activity: {
                el: "Δραστηριότητα Επιχείρησης",
                en: "Business Activity",
                it: "Attività commerciale"
            },
            telephone: {
                el: "Τηλέφωνο Επιχείρησης",
                en: "Business Telephone Number",
                it: "Numero di telefono dell'azienda"
            },
            ownersPhone: {
                el: "Τηλέφωνο  Ιδιοκτήτη",
                en: "Owner's Mobile Phone",
                it: "Numero di telefono del proprietario"
            },
            email: {
                el: "Email",
                en: "Email",
                it: "Email"
            },
            googleMaps: {
                el: "Προβολή στους Χάρτες",
                en: "View on Google Maps",
                it: "Visualizza su Google Maps"
            }
        }
    })
};
